<template lang="pug">
  .page.contacts
    header.page__header.contacts__header
      main-header
    main.page__main
      .container
        .contacts__container
          .contacts__block
            section.contacts__section.contacts-section
              .contacts-section__title
                h2.title Напишите нам
              .contacts-section__main
                feedback-form
          .contacts__block
            section.contacts__section.contacts-section
              .contacts-section__title
                h2.title Контакты
              .contacts-section__main
                contacts-list
            section.contacts__section.contacts-section
              .contacts-section__title
                h2.title Мы в социальных сетях
              .contacts-section__main
                social-networks(
                :mode="'dark'"
                )
    footer.page__footer
      main-footer
</template>

<script>
import MainHeader from "../../components/main-header/main-header";
import MainFooter from "../../components/main-footer/main-footer";
import ContactsList from "./components/contacts-list";
import SocialNetworks from "../../components/social-networks/social-networks";
import FeedbackForm from "../../components/feedback-form/feedback-form";
export default {
  name: "Contacts",
  components: {
    FeedbackForm,
    SocialNetworks,
    ContactsList,
    MainFooter,
    MainHeader,
  },
};
</script>
